<button
    mat-button
    class="d-flex align-items-center scss-chip-button gap-1 text-truncate"
    [matMenuTriggerFor]="menuTrigger"
    [attr.data-sb-qa]="qaTag"
    (click)="Clicked(); $event.stopPropagation()">
    <ng-content></ng-content>
    <lib-icon
        *ngIf="hasCarretSuffix"
        [icon]="Icon.Common.CaretDown"></lib-icon>
</button>
